import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
const loadGammaPageLayout = async () => {
    const { GammaPageLayout } = await import('#pplx/frontend/apps/ask/computer/GammaPageLayout.js');
    return { default: GammaPageLayout };
};
export const GammaPageLayoutRoute = Dynamic(loadGammaPageLayout, {
    critical: true,
});
//# sourceMappingURL=GammaPageLayoutRoute.js.map